import { EnvironmentCompany } from '@cp/shared/environment/environment.interface';

export type DeploymentType =
  | 'local'
  | 'development'
  | 'testa'
  | 'uat'
  | 'production';

export type EnvironmentOrganization = EnvironmentCompany;

export type DeploymentUrl = {
  [K in EnvironmentOrganization]: string;
};

export type DeploymentUrls = {
  [K in DeploymentType]: DeploymentUrl;
};

export type SimpleDeploymentUrls = {
  [K in DeploymentType]: string;
};

export const COMPLIANCE_PORTAL_DEPLOYMENT_URLS: DeploymentUrls = {
  local: {
    tns: 'http://tns.localhost:4200',
    sng: 'http://sng.localhost:4200',
  },
  development: {
    tns: 'https://dev.compliance-thornbury.com',
    sng: 'https://dev.compliance-theguild.com',
  },
  testa: {
    tns: 'https://testa.compliance-thornbury.com',
    sng: 'https://testa.compliance-theguild.com',
  },
  uat: {
    tns: 'https://uat.compliance-thornbury.com',
    sng: 'https://uat.compliance-theguild.com',
  },
  production: {
    tns: 'https://compliance-thornbury.com',
    sng: 'https://compliance-theguild.com',
  },
};

export const RECRUITMENT_PORTAL_DEPLOYMENT_URLS: DeploymentUrls = {
  local: {
    tns: 'http://tns.localhost:4200',
    sng: 'http://sng.localhost:4200',
  },
  development: {
    tns: 'https://tns-development.joinx.co.uk',
    sng: 'https://tns-development.joinx.co.uk',
  },
  testa: {
    tns: 'https://tns-e2e.joinx.co.uk',
    sng: 'https://tns-e2e.faberodt.com',
  },
  uat: {
    tns: 'https://tns-uat.joinx.co.uk',
    sng: 'https://tns-uat.faberodt.com',
  },
  production: {
    tns: 'https://join-thornbury.com',
    sng: 'https://join-theguild.com',
  },
};

export const GLOBAL_DASHBOARD_DEPLOYMENT_URLS: SimpleDeploymentUrls = {
  local: 'https://dashboard-dev.tnssng.com',
  development: 'https://dashboard-dev.tnssng.com',
  testa: 'https://dashboard-testa.tnssng.com',
  uat: 'https://dashboard-integration.tnssng.com',
  production: 'https://dashboard.tnssng.com/',
};
